import React from 'react';
import { Divider } from 'antd';

import {
 Content,
 Head,
 ConnectName,
 Text,
 Title,
 DeviceName,
 NumberDevice,
} from '../../ModalStyled.styled';
import { ErrorIcon } from './../../../../_assests';

export default function CapacityWarning({ connectName, meterings, error }) {
 const lengthValue = JSON.parse(sessionStorage.getItem('meteringForm'));
 //sessionStorage.removeItem('isSecondProcess');

 const checkNumberDevice = meterings?.filter((metering, index) => {
  if (
   lengthValue[`volume-${index}`] !== null &&
   lengthValue[`volume-${index}`] !== '' &&
   lengthValue[`volume-${index}`] !== undefined
  ) {
   return metering;
  }
  return null;
 });

 return (
  <Content>
   <Head>
    <ErrorIcon />
    <Title>Проверьте корректность введенных показаний</Title>
   </Head>
   <Divider />
   {checkNumberDevice?.map((item, idx) => {
    if (lengthValue[`volume-${idx}`] < item.previousScaleReadings)
     return (
      <>
       <ConnectName>{connectName}</ConnectName>
       <DeviceName>Заводской номер прибора учета</DeviceName>
       <NumberDevice>{item.meteringDeviceNumber}</NumberDevice>
       <Text>Текущие показания не могут быть меньше, чем предыдущие.</Text>
      </>
     );
    if (
     item.meteringDeviceSignificance === null ||
     lengthValue[`volume-${idx}`]?.length > item.meteringDeviceSignificance
    )
     return (
      <>
       <ConnectName>{connectName}</ConnectName>
       <DeviceName>Заводской номер прибора учета</DeviceName>
       <NumberDevice>{item.meteringDeviceNumber}</NumberDevice>
       <Text>
        Разрядность вашего прибора учета не совпадает с передаваемыми
        показаниями. Проверьте правильность количества символов до или после
        запятой.
       </Text>
      </>
     );
    if (
     error === '100210' ||
     error === '100212' ||
     error === '100213' ||
     error === '100215' ||
     error === '100216' ||
     error === '100217' ||
     error === '100218' ||
     error === '100219'
    )
     return (
      <>
       <ConnectName>{connectName}</ConnectName>
       <DeviceName>Заводской номер прибора учета</DeviceName>
       <NumberDevice>{item.meteringDeviceNumber}</NumberDevice>
       <Text>
        Показания не приняты к расчету. Обратитесь в справочную службу.
       </Text>
      </>
     );
    return null;
   })}
  </Content>
 );
}
